import styled from '@emotion/styled'

export const FFSErrorMessage = styled.p`
font-size: 14px;
line-height: 28px;
font-weight: 500;
color: red;
margin-top: -15px !important;
margin-bottom: 22px !important;
`;